import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { BidService } from '../../../services/bids.service';
import { UpdateBidData } from '../../../interfaces/data-models';
import { ScreenSizeService } from "../../../services/screen-size.service";
import { PaymentService } from 'src/app/services/payment/user-wallet.service';
import { switchMap, of } from 'rxjs';
import { Router } from '@angular/router';
import { GenericMessage } from '../../../shared/generic-message/generic-message.component';

@Component({
  selector: 'app-update-fixed-rate-bid',
  templateUrl: './update-fixed-rate-bid.component.html',
  styleUrls: ['./update-fixed-rate-bid.component.css']
})
export class UpdateFixedRateBidComponent implements OnInit {
  modalForm!: FormGroup;
  isMobile: boolean = false;
  isLoading = false;
  apiError: string | null = null; 

  constructor(
    @Inject(MAT_DIALOG_DATA) public currentBid: UpdateBidData & { transaction_type: string },
    private fb: FormBuilder,
    private bidService: BidService,
    private paymentService: PaymentService,
    private dialogRef: MatDialogRef<UpdateFixedRateBidComponent>,
    private router: Router,
    private screenSizeService: ScreenSizeService,
    private dialog: MatDialog
  ) {
    this.modalForm = this.fb.group({
      bidPrice:       [parseFloat(currentBid.bidPrice),   [Validators.required, Validators.min(0.01)]],
      energy_amount: [parseFloat(currentBid.energyAmount), [Validators.required, Validators.min(0.01)]],
    });
  }

  ngOnInit() {
     this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  get bidPrice() {
    return this.modalForm.get('bidPrice');
  }

  get energy_amount() {
    return this.modalForm.get('energy_amount');
  }

  submitBid() {
    if (this.modalForm.invalid) return;
    this.isLoading = true;
    this.apiError = null;

    const newEnergy = this.modalForm.value.energy_amount;
    const newPrice  = this.modalForm.value.bidPrice;
    const txnTypeId = this.currentBid.transaction_type === 'Buy' ? 1 : 2;

    this.paymentService.validateBalance({
      bid_price:            newPrice,
      energy_amount:        newEnergy,
      bid_id:               this.currentBid.bidId,
      transaction_type_id:  txnTypeId
    }).pipe(
      switchMap(res => {
        const req = parseFloat(res.required_balance ?? '0');
        console.log(res);
        if (req > 0) {
          return this.paymentService.addTokens({
            amount:         req,
            payment_method: 'icici_cbdc',
            device:         'web'
          });
        }
        return of({ no_action_needed: true });
      })
    ).subscribe({
      next: (resp:any) => {

        if (resp && resp.payment_intent) {

          const ctx = {
            intentLink:    resp.payment_intent.intent_link,
            txId:          resp.payment_intent.transaction_id,
            amount:        resp.payment_intent.amount,
            message:       resp.payment_intent.message,
            qr_code:       resp.qr_code,
            returnRoute:   `/fixed-rate-bid/${this.currentBid.bidId}`,
            transactionType: txnTypeId,
            preferentialEditContext: {
              bid_id:        this.currentBid.bidId,
              bid_round_id:  this.currentBid.bidRoundId,
              energy_amount: newEnergy,
              bid_price:     newPrice
            },
            display: { title: 'Update Fixed-Rate Bid Payment' }
          };
          sessionStorage.setItem('pendingPaymentContext', JSON.stringify(ctx));
          this.isLoading = false;
          this.dialogRef.close('payment-redirect');
          this.router.navigate(['/payment'], { state: ctx });
        } else {

          this.bidService.updatePreferentialBid({
            bid_id:        this.currentBid.bidId,
            bid_round_id:  this.currentBid.bidRoundId,
            energy_amount: newEnergy,
            bid_price:     newPrice
          }).subscribe({
            next: () => {
              this.isLoading = false;
              this.dialogRef.close('success');
            },
            error: (err) => {
              this.isLoading = false;
              const message =
                (err && err.error && (err.error.detail || err.error.message)) ||
                err?.message ||
                'Failed to update bid. Please try again.';
              this.apiError = message;
              this.dialog.open(GenericMessage, {
                data: { title: 'Error', message }
              });
            }
          });
        }
      },
      error: err => {

        this.isLoading = false;
        const message =
          (err && err.error && (err.error.detail || err.error.message)) ||
          err?.message ||
          'An error occurred during payment validation.';
        this.apiError = message;
        this.dialog.open(GenericMessage, {
          data: { title: 'Error', message }
        });
      }
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
